import React, { Component } from 'react'
import Col from 'react-bootstrap/Col'
import '../../wallet.css'
import './transferir.css'
import { Select } from 'antd'

const Option = Select.Option

class ListaFavoritos extends Component {
    constructor(props) {
    super(props)
    this.state = {
    }}


        render() {
            
            return (
    
                <>              
                                <Col md={12} className="p-0">
                                    {!this.props.isLoading && this.props.favorites.length > 0 ? 
                                    <Select className="inputTransferir" defaultValue={this.props.favorites[0].id}>
                                        {this.props.favorites.map(favorite => (
                                            <Option value={favorite.id}>{favorite.nome}</Option>
                                        ))}
                                    </Select> : 'Você ainda não tem favoritos.' }
                                </Col>
                </>
            )
        }
    }

export default ListaFavoritos